export const MONTHS_EN = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const TRANSACTION_MESSAGE_TYPE = [
  { displayName: 'All', value: '' },
  { displayName: 'Order confirmation', value: 'order_confirmation' },
  { displayName: 'Awaiting payment', value: 'payment_awaiting' },
  { displayName: 'Awaiting payment reminder', value: 'awaiting_order_reminder' },
  { displayName: 'Payment Failure', value: 'payment_failure' },
  { displayName: 'Downline payment', value: 'downline_payment' },
  { displayName: 'Bonus Payment', value: 'bonus' },
  { displayName: 'ABO - POOL', value: 'ABO_POOL' },
  { displayName: 'GMN - Create new profile', value: 'GMN - Create new profile' },
  { displayName: 'GMN - Edit profile', value: 'gmn_editprofile' },
  { displayName: 'GMN - Order confirmation', value: 'gmn_orderconfirmation' },
  { displayName: 'GMN - Awaiting order', value: 'gmn_awaitingorder' },
  { displayName: 'GMN - Profile cancelled', value: 'gmn_profilecancelled' },
  { displayName: 'GMN - All active profiles', value: 'gmn_allactiveprofiles' },
  { displayName: 'GMN - Daily greeting', value: 'GMN_GREETING' },
  { displayName: 'GMN - Daily checklist', value: 'GMN_CHECKLIST' },
  { displayName: 'LON - Registration', value: 'lon_registration' },
  { displayName: 'LON - Renewal reminder', value: 'lon_renewal' },
]

export const MESSAGE_DELIVERY_STATUS = [
  'Total',
  'Pending',
  'Delivered',
  'Resend',
  'Failed'
]